<template>
  <v-app id="home">
    <v-main class="background-home">
      <view-container>
        <v-container>
          <v-row>
            <v-col cols="2">
              <basic-btn
                xLarge
                icon="mdi-arrow-left"
                @click="$router.push('/login')"
              />
            </v-col>
            <v-col cols="10">
              <h1 style="color: #005591" v-text="'Recupera tu password'" />
            </v-col>
          </v-row>
        </v-container>
        <auto-container>
          <v-container>
            <v-row class="mb-6 text-center" justify="center">
              <v-col cols="12" md="12" class="padding-b0 padding-t10">
                <BasicInput
                  v-model="username"
                  placeholder="Ingresa tu usuario"
                />
              </v-col>
              <v-col cols="12" md="12" class="padding-b0 padding-t0">
                <basic-btn
                  block
                  text="Recuperar Contraseña"
                  @click="recovery"
                />
              </v-col>
            </v-row>
          </v-container>
        </auto-container>
      </view-container>
    </v-main>
  </v-app>
</template>

<script>
import {
  AutoContainer,
  ViewContainer,
  BasicInput,
  BasicBtn,
} from "@/components";
import { services, alertMsg } from "@/utils";

export default {
  name: "home",
  components: { AutoContainer, ViewContainer, BasicInput, BasicBtn },
  data: () => ({
    username: "",
    rules: {},
    dialogs: {},
    links: {},
  }),
  mounted() {},
  methods: {
    recovery() {
      let data = {
        data: {
          username: parseInt(this.username),
        },
      };
      this.loading = true;
      setTimeout(() => {
        this.axios
          .post(services.routes.recoveryPassword, data)
          .then((response) => {
            alertMsg.alert(
              "Se ha enviado un correo electrónico para recuperar su contraseña",
              "success"
            );
          })
          .catch((error) => {
            alertMsg.alert(
              "Los datos introducidos son incorrectos, favor de verificar",
              "error"
            );
          })
          .finally(() => {
            this.loading = false;
          });
      }, 300);
    },
  },
};
</script>

<style scoped>
.padding-b0 {
  padding-bottom: 0px;
}
.padding-t0 {
  padding-top: 0px;
}
.padding-t10 {
  padding-top: 10%;
}
.alignText {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>
